import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL, optionStatuses } from "../../redux/actions/constants";
import { withRouter } from "react-router-dom";
class GmailApiInformationAddUpdate extends Component {
  state = {
    pageTitle: "GMail API Bilgileri Ekle",
    pageTitleAdd: "GMail API Bilgileri Ekle",
    pageTitleUpdate: "GMail API Bilgileri Güncelle",
    pageAddLink: "gmail-api-bilgileri-ekle",
    pageListLink: "gmail-api-bilgileri-listele",
    breadcrumb: [{ text: "GMail API Bilgileri", link: "#" }],
    isLoading: false,
    urlSplit: [],
    membershipGuid: "",
    membershipGuidError: "",
    clientId: "",
    clientIdError: "",
    clientSecret: "",
    clientSecretError: "",
    smtpPassword: "",
    smtpPasswordError: "",
    guid: "",
    status: true,
    alertErrorMessage: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
  };
  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/users/getlistuser", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          userArr: myArr,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    if (urlSplit.length === 3) {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
        isLoading: true,
      });
      this.getById(urlSplit[2]);
      axios
        .get(URL + "/gmailapiinformation/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              guid: response.data.guid,
              membershipGuid: response.data.membershipGuid,
              clientId: response.data.clientId,
              clientSecret: response.data.clientSecret,
              smtpPassword: response.data.smtpPassword,
              status: response.data.status,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }
  componentDidUpdate() {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        urlSplit: urlSplit,
        pageTitle: this.state.pageTitleAdd,
        guid: "",
        membershipGuid: "",
        clientId: "",
        clientSecret: "",
        smtpPassword: "",
        status: true,
      });
    }
    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
  }
  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      clientIdError: "",
      clientSecretError: "",
      smtpPasswordError: "",
      alertErrorMessage: "",
    });
    if (name === "clientId" && value === "") {
      this.setState({
        clientIdError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "clientSecret" && value === "") {
      this.setState({
        clientSecretError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "smtpPassword" && value === "") {
      this.setState({
        smtpPasswordError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };
  handleClear = (event) => {
    this.clearPage();
  };
  clearPage() {
    this.setState({
      membershipGuid: "",
      membershipGuidError: "",
      clientId: "",
      clientIdError: CgnMessage.textErrorMessage,
      clientSecret: "",
      clientSecretError: CgnMessage.textErrorMessage,
      smtpPassword: "",
      smtpPasswordError: CgnMessage.textErrorMessage,
      status: true,
      alertErrorMessage: CgnMessage.alertErrorMessage,
    });
  }
  handleStatusSelectChange(status) {
    this.setState({ status: status.value });
  }
  handleUserSelectChange(option) {
    if (option) {
      this.setState({
        membershipGuid: option.value,
        membershipGuidError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        membershipGuid: null,
        membershipGuidError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }
  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      alertErrorMessage: "",
      membershipGuidError: "",
      clientIdError: "",
      clientSecretError: "",
      smtpPasswordError: "",
    });
    if (this.state.membershipGuid === "") {
      this.setState({
        membershipGuidError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (this.state.clientId === "") {
      this.setState({
        clientIdError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (this.state.clientSecret === "") {
      this.setState({
        clientSecretError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (this.state.smtpPassword === "") {
      this.setState({
        smtpPasswordError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (
      this.state.membershipGuid !== "" &&
      this.state.clientId !== "" &&
      this.state.clientSecret !== "" &&
      this.state.smtpPassword !== ""
    ) {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        membershipGuid: this.state.membershipGuid,
        clientId: this.state.clientId,
        clientSecret: this.state.clientSecret,
        smtpPassword: this.state.smtpPassword,
        status: this.state.status,
      };
      var URLParam = "/gmailapiinformation/add";
      if (
        this.state.guid &&
        this.state.urlSplit.length !== 2 &&
        this.state.urlSplit[1] === "gmail-api-bilgileri-guncelle"
      ) {
        URLParam = "/gmailapiinformation/update";
        myObj = {
          guid: this.state.guid,
          membershipGuid: this.state.membershipGuid,
          clientId: this.state.clientId,
          clientSecret: this.state.clientSecret,
          smtpPassword: this.state.smtpPassword,
          status: this.state.status,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (
              this.state.guid &&
              this.state.urlSplit[1] === "gmail-api-bilgileri-guncelle"
            ) {
              window.location.href = "/gmail-api-bilgileri-listele";
            }
            if (this.state.urlSplit[1] === "gmail-api-bilgileri-ekle") {
              window.location.reload();
            }
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };
  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "gmail-api-bilgileri-ekle" ||
          this.state.urlSplit[1] === "gmail-api-bilgileri-guncelle") && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />
                <Row>
                  <Col lg="3">
                    <CgnReactSelect
                      name="membershipGuid"
                      label="Kullanıcı [*]"
                      placeholder="Kullanıcı seçiniz..."
                      selectValue={this.state.membershipGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) => this.handleUserSelectChange(option)}
                      options={this.state.userArr}
                      error={this.state.membershipGuidError}
                    />
                  </Col>
                  <Col lg="9"></Col>
                </Row>
                <Row>
                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="clientId"
                      label="Client Id [*]"
                      value={this.state.clientId}
                      placeHolder="Lütfen Client Id bilgileri girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.clientIdError}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="clientSecret"
                      label="Client Secret [*]"
                      value={this.state.clientSecret}
                      placeHolder="Lütfen Client Secret bilgileri girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.clientSecretError}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="smtpPassword"
                      label="SMTP Uygulama Şifresi [*]"
                      value={this.state.smtpPassword}
                      placeHolder="Lütfen SMTP Şifresi bilgileri girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.smtpPasswordError}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="3">
                    <CgnReactSelect
                      name="status"
                      label="Durumu"
                      isMulti={false}
                      selectValue={this.state.status}
                      options={optionStatuses}
                      onChange={(status) =>
                        this.handleStatusSelectChange(status)
                      }
                    />
                  </Col>
                  <Col lg="9"></Col>
                </Row>
                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>
            {(this.state.urlSplit[1] === "gmail-api-bilgileri-ekle" ||
              this.state.urlSplit[1] === "gmail-api-bilgileri-guncelle") && (
              <CgnButtonLink
                color="secondary"
                to={"/" + this.state.pageListLink}
                text={CgnMessage.backButton}
                className="btn-back"
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}
export default withRouter(GmailApiInformationAddUpdate);
